var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "form-item-wrapper",
    {
      attrs: {
        designer: _vm.designer,
        field: _vm.field,
        rules: _vm.rules,
        "design-state": _vm.designState,
        "parent-widget": _vm.parentWidget,
        "parent-list": _vm.parentList,
        "index-of-parent-list": _vm.indexOfParentList,
        "sub-form-row-index": _vm.subFormRowIndex,
        "sub-form-col-index": _vm.subFormColIndex,
        "sub-form-row-id": _vm.subFormRowId,
      },
    },
    [
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: !_vm.getReadMode(),
              expression: "!getReadMode()",
            },
          ],
          ref: "fieldEditor",
        },
        [
          _c(
            "div",
            { staticClass: "pic-list" },
            [
              _vm._l(_vm.fieldModel, function (img, index) {
                return _vm.fieldModel.length
                  ? _c("div", { key: index, staticClass: "pic" }, [
                      _c("img", {
                        staticClass: "img",
                        attrs: { src: img.url },
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "pic-upload" }, [
                        _c("div", { staticClass: "pic-upload-content" }, [
                          _c("i", {
                            staticClass: "el-icon-zoom-in",
                            on: {
                              click: function ($event) {
                                return _vm.handlePictureCardPreview(index)
                              },
                            },
                          }),
                          _vm._v(" "),
                          _c("i", {
                            staticClass: "el-icon-delete",
                            on: {
                              click: function ($event) {
                                return _vm.handleAvatar(index)
                              },
                            },
                          }),
                        ]),
                      ]),
                    ])
                  : _vm._e()
              }),
              _vm._v(" "),
              _vm.fieldModel.length < _vm.field.options.limit
                ? _c("i", {
                    staticClass: "el-icon-plus pic-uploader-icon",
                    on: { click: _vm.beforeUpload },
                  })
                : _vm._e(),
            ],
            2
          ),
        ]
      ),
      _vm._v(" "),
      [
        _vm.getReadMode()
          ? _c("div", [
              _vm.fieldModel.length
                ? _c(
                    "div",
                    { staticClass: "pic-list" },
                    _vm._l(_vm.fieldModel, function (img, index) {
                      return _c("div", { key: index, staticClass: "pic" }, [
                        _c("img", {
                          staticClass: "img",
                          attrs: { src: img.url },
                        }),
                        _vm._v(" "),
                        _c("div", { staticClass: "pic-upload" }, [
                          _c("div", { staticClass: "pic-upload-content" }, [
                            _c("i", {
                              staticClass: "el-icon-zoom-in",
                              on: {
                                click: function ($event) {
                                  return _vm.handlePictureCardPreview(index)
                                },
                              },
                            }),
                          ]),
                        ]),
                      ])
                    }),
                    0
                  )
                : _c("div", [_vm._v("--")]),
            ])
          : _vm._e(),
      ],
      _vm._v(" "),
      _vm.showPreviewDialogFlag
        ? _c(
            "el-dialog",
            {
              directives: [{ name: "dialog-drag", rawName: "v-dialog-drag" }],
              attrs: {
                title: "",
                visible: _vm.showPreviewDialogFlag,
                "append-to-body": "",
                width: "60%",
                "show-close": true,
                "custom-class": "drag-dialog small-padding-dialog",
                "close-on-click-modal": true,
                "close-on-press-escape": true,
                "destroy-on-close": true,
              },
              on: {
                "update:visible": function ($event) {
                  _vm.showPreviewDialogFlag = $event
                },
              },
            },
            [
              _c("img", {
                attrs: { src: _vm.previewUrl, width: "100%", alt: "" },
              }),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          directives: [{ name: "dialog-drag", rawName: "v-dialog-drag" }],
          attrs: {
            title: "选择图片",
            "custom-class": "drag-dialog small-padding-dialog",
            visible: _vm.dialogVisible,
            "append-to-body": "",
            width: "850px",
            "before-close": _vm.handleClose,
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
          },
        },
        [
          _c("upload-picture", {
            ref: "uploadPicture",
            attrs: {
              maxNum: Number(_vm.field.options.limit),
              multiple: true,
              "check-button": true,
            },
            on: { getImage: _vm.getImage },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _vm.isImage
        ? _c("el-image-viewer", {
            attrs: {
              "on-close": _vm.closeImageViewer,
              "url-list": _vm.srcList,
            },
          })
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }